import { environment } from '@mg-platform/core/core-util'

export const SHOPS_API_URL = {
  base: (shopId?: string) => `${environment.apiUrl}/shops${shopId ? '/' + shopId : ''}`,
  getOneShop: (shopId: string, withLastReportDate?: boolean) =>
    `${environment.apiUrl}/shops/${shopId}${withLastReportDate ? '/' + withLastReportDate : ''}`,
  setShopFocus: (shopId?: string) => `${environment.apiUrl}/shops/focus/${shopId}`,

  // Shop Users
  getShopUsers: (shopId?: string) => `${environment.apiUrl}/shops/${shopId}/shopusers`,
  getShopPendingUsers: (shopId?: string) => `${environment.apiUrl}/shops/${shopId}/shoppendingusers`,
  updateUserShopAccess: `${environment.apiUrl}/shops/update-user-shop-access`,

  // Shop Groups
  updateShopGroup: `${environment.apiUrl}/groups`,
  deleteShopGroup: (groupId: string) => `${environment.apiUrl}/groups/${groupId}`,
  autoCreateShopGroups: `${environment.apiUrl}/groups/auto-create`,

  // Admin Shops
  adminShop: (shopId: string) => `${environment.apiUrl}/admin/shops/${shopId}`,
  adminGetAllShops: `${environment.apiUrl}/admin/filters/shops`,
  adminGetUnimportedShops: `${environment.apiUrl}/admin/filters/unimported-shops`,
  adminExportAllShops: `${environment.apiUrl}/admin/filters/shops/export`,
  adminDeclineShop: (shopId: string) => `${environment.apiUrl}/admin/shops/${shopId}/decline`,
  adminVerifyShop: (shopId: string) => `${environment.apiUrl}/admin/shops/${shopId}/verify`,
  adminDeleteShop: (shopId: string) => `${environment.apiUrl}/admin/shops/${shopId}`,
  adminDeleteShopUser: (shopId: string, userId: string) =>
    `${environment.apiUrl}/admin/shops/${shopId}/${userId}`,
  adminDailyReportsShops: `${environment.apiUrl}/admin/shops/dailyreportshops`,
  adminShopTagSize: `${environment.apiUrl}/admin/shops/tag-size`,
  adminShopOperations: (shopId: string) => `${environment.apiUrl}/admin/shops/${shopId}/operations`,
  adminGetAllGroups: `${environment.apiUrl}/admin/filters/groups`,
  adminExportAllGroups: `${environment.apiUrl}/admin/filters/groups/export`
}
